import { queryClient, apiRequest } from "../lib/queryClient";

const triggerKey = "trigger";

export function useTrigger(options = {}) {
  const {
    filters = {},
    sort = { field: "created_at", direction: "desc" },
    pagination = { page: 1, limit: 10 },
  } = options;

  const fetchTrigger = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pagination.page);
    queryParams.append("limit", pagination.limit);
    queryParams.append("sortField", sort.field);
    queryParams.append("sortDirection", sort.direction);

    for (const [key, value] of Object.entries(filters)) {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, value);
      }
    }
    const response = await apiRequest(
      `/admin/trigger?${queryParams.toString()}`,
      {
        method: "GET",
      }
    );
    return response;
  };

  const createTrigger = async (pageData) => {
    const response = await apiRequest("/user/trigger", {
      method: "POST",
      body: JSON.stringify(pageData),
    });
    queryClient.invalidateQueries({ queryKey: [triggerKey] });
    return response;
  };

  const updateTrigger = async (pageData) => {
    const { _id, ...rest } = pageData;
    const response = await apiRequest(`/admin/trigger/${_id ? _id : ""}`, {
      method: "PUT",
      body: JSON.stringify(rest),
    });
    queryClient.invalidateQueries({ queryKey: [triggerKey] });
    return response;
  };

  const deleteTrigger = async (pageId) => {
    await apiRequest(`/admin/trigger/${pageId}`, {
      method: "DELETE",
    });
    queryClient.invalidateQueries({ queryKey: [triggerKey] });
    return pageId;
  };

  

//    const toggleTriggerStatus = async (id) => {
//       const response = await apiRequest(`/admin/trigger/${id}`, {
//         method: "PATCH",
//       });
//       queryClient.invalidateQueries({ queryKey: [triggerKey] });
//       return response;
//     };

  return {
   fetchTrigger,
    createTrigger,
    updateTrigger,
    deleteTrigger,
    // toggleTriggerStatus,
  };
}
